const INITIAL_STATE = {
  companiesList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_COMPANIES': {
      return { ...state, companiesList: action.companies };
    }
    default:
      return state;
  }
};
